import GameObject from '../../GameObject/GameObject';
import { Point } from 'pixi.js';
import BaseCard from '../Level/Card/BaseCard';
import { StartAnimation } from '../../System/Animation/AnimationHelper';
import { delay } from '../../Utility/Task/TaskQueue';

export class LoadingScreen extends GameObject {
    private cards: BaseCard[];
    private onPlay = true;
    protected onCreate(): void {
        const nCards = 6;
        this.cards = this.createCards(nCards);
    }

    private createCards(nCards: number) {
        const cards: BaseCard[] = [];
        const range = 120;
        const step = (2 * Math.PI) / nCards;

        for (let i = 0; i < nCards; i++) {
            const position = new Point(
                Math.cos(i * step) * range,
                Math.sin(i * step) * range
            );
            const card = GameObject.Instantiate(BaseCard, {
                cardBackTexture: 'loading-screen-back-face-card',
                cardFrontTexture: 'loading-screen-front-face-card',
                position,
                rotation: Math.atan2(position.x, -position.y),
                scale: new Point(0.5, 0.5),
                anchor: new Point(0.5, 0.5),
            });
            cards.push(card);
            this.addChild(card);
        }
        return cards;
    }

    public *animate(faceUp?: boolean): IterableIterator<number> {
        for (let i = 0; i < this.cards.length; i++) {
            if (this.onPlay) {
                StartAnimation(this.cards[i], 'CardFlip', {
                    noCardSystem: true,
                    faceUp,
                });
                yield* delay(100);
            } else {
                break;
            }
        }

        if (this.onPlay) {
            yield* delay(800);
            yield* this.animate(!faceUp);
        }
    }

    public stopAnimation() {
        this.onPlay = false;
    }
}
